import {
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { makeStyles, styled } from "@mui/styles";
import PropTypes from "prop-types";

const useStyles = makeStyles(() => ({
  tableHead: {
    backgroundColor: "#f5f2e6",
  },
  topContent: {
    display: "flex",
    margin: "10px",
    padding: "5px",
    justifyContent: "space-between",
    borderRadius: "5px",
    background: 'white',
    '&:hover': {
      boxShadow: "0px 4px 12px rgba(155, 55, 137, 0.2)",
    }
  }

}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#499178",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:hover": {
    backgroundColor: "#f0faf6",
  },
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
    "&:hover": {
      backgroundColor: "#f0faf6",
    },
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function FarmerActivity({ title, dashboard }) {
  // Material UI State
  const styles = useStyles();

  // Redux State
  const data = useSelector((state) => state.reportDailyActivity.data);

  const column = ["Petani", "Area"];
  const listData = ["farmerName", "workingArea"];
  return (
    <div>
      <div className={styles.topContent}>
        <Typography fontWeight={700} fontSize={16}>{title}</Typography>
        <Typography color="gray">
          {moment().subtract(1, "days").locale("id").format("dddd, DD-MM-YYYY")}{" "}
        </Typography>
      </div>
      <TableContainer sx={{ maxHeight: 440, borderRadius: 5, marginTop: 2 }}>
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead className={styles.tableHead}>
            <StyledTableRow>
              {column.length > 0 &&
                column.map((item, index) => (
                  <StyledTableCell align="center" key={index}>
                    {item}
                  </StyledTableCell>
                ))}
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {data[`${dashboard}`].length > 0 &&
            data[`${dashboard}`][0][
              moment().subtract(1, "days").format("DD - MMMM - YYYY")
            ].length > 0 ? (
              data[`${dashboard}`][0][
                moment().subtract(1, "days").format("DD - MMMM - YYYY")
              ].map((row, index) => (
                <StyledTableRow key={index}>
                  {listData.map((item, index) => {
                    return (
                      <StyledTableCell
                        style={{ width: 160 }}
                        align="center"
                        key={index}
                      >
                        {row[item] ? row[item] : "-"}
                      </StyledTableCell>
                    );
                  })}
                </StyledTableRow>
              ))
            ) : (
              <StyledTableRow>
                <StyledTableCell style={{ width: "100%" }} align="center">
                  Tidak ada data
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

FarmerActivity.propTypes = {
  title: PropTypes.string,
  dashboard: PropTypes.string,
};
